export default {
  methods: {
    toSelectOptions(arrayWithStrings) {
      if (!Array.isArray(arrayWithStrings)) {
        return []
      }
      return arrayWithStrings.map(a => ({ text: a, value: a }))
    },
    codeIsFreeform(codeOptionSetting) {
      return codeOptionSetting !== 'Y'
    },
    codeIsRequired(codeOptionSetting) {
      return codeOptionSetting === 'Y' || codeOptionSetting === 'N'
    }
  }
}
